import { TRAFFIC_TYPE } from 'pages/provisioning/aws/external-url-onboarding/constant';

export const formOrderObjFromOrderDetails = (catalogServiceId = null, data = null) => {
    const entityDetails = data?.entityDetails || null;
    const catalog = data?.catalogServices?.find((item) => item?.catalogServiceId === catalogServiceId) || null;
    const catalogConfig = catalog?.catalogConfig || null;
    const environmentDetails = catalogConfig?.environmentDetails || null;
    return {
        // Common fields
        entityDetails: {
            ...entityDetails,
        },
        appProfile: entityDetails?.name,
        ...(entityDetails?.name && { appProfileDetails: { label: entityDetails?.name, value: entityDetails?.name } }),
        sector: catalogConfig?.sector || null,
        environment: catalogConfig?.environment || null,
        region: catalogConfig?.region || environmentDetails?.region || null,
        appRegion: catalogConfig?.applicationRegion || null,
        applicationName: catalogConfig?.applicationName || null,
        appUrl: catalogConfig?.applicationUrl || null,
        isAppUrlValid: true,
        supportBackendCertificate: catalogConfig?.supportBackendCertificate || null,
        adCertGroup: catalogConfig?.activeDirectoryCertificateGroup || null,
        dataClassification: catalogConfig?.dataClassification || null,
        appSupportMailId: catalogConfig?.appSupportMailId || null,
        infosecAppUrl: catalogConfig?.infosecAppUrl || null,
        infosecEnvironment: catalogConfig?.infosecEnvironment || null,
        hCode: environmentDetails?.costCenter || null,
        ...(environmentDetails?.costCenter && {
            hCodeDetails: { label: environmentDetails?.costCenter, value: environmentDetails?.costCenter, projectName: environmentDetails?.projectName },
        }),
        ...(!environmentDetails?.costCenter && { hCodeDetails: null }),
        appOwner: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
        appOwnerDetails: {
            label: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
            gpid: entityDetails?.applicationManagerGpid,
            name: entityDetails?.applicationManager,
            email: entityDetails?.applicationManagerEmail,
        },
        availabilityZone:
            catalogConfig?.availabilityZone?.map((item) => ({
                label: item,
                value: item,
            })) || null,
        loadBalancerType: catalogConfig?.onboardingType,
        trafficType: catalogConfig?.trafficType || null,
        catalogCode: catalog?.catalogServiceCode,
        catalogType: catalog?.catalogType,
        cloudProvider: catalog?.cloudProvider,
        cloudService: catalog?.cloudService,
        estimatedCost: catalogConfig?.estimatedCost || null,
        ...(catalogConfig?.isaNumber && {
            isaNumber: catalogConfig?.isaNumber,
            isaValidation: true,
        }),
        enabledManualBudgetCode: catalogConfig?.enabledManualBudgetCode || true,
        validationStatus: 'clearValidation',
        isTouched: false,

        // ALB-specific fields
        ...(catalogConfig?.trafficType === TRAFFIC_TYPE.ALB && {
            department: catalogConfig?.department || null,
            awsAccount: environmentDetails?.awsAccountName || null,
            awsAccountId: environmentDetails?.awsAccountId || null,
            appShortName: catalogConfig?.applicationShortName || null,
            isAlbRequired: catalogConfig?.externalAlbExists ? 'yes' : 'no',
            loadBalancerDetails: {
                sharedNetworkAccount: catalogConfig?.sharedNetworkAccount || null,
                accountId: catalogConfig?.sharedNetworkAccountId || null,
                awsVpcId: catalogConfig?.awsVpcId || null,
                albNameInternal: catalogConfig?.externalAlbName || null,
                albArn: catalogConfig?.externalAlbArn || null,
                nlbNameInternal: catalogConfig?.externalNlbName || null,
                nlbArn: catalogConfig?.externalNlbArn || null,
                dnsName: catalogConfig?.dnsName || null,
                nlbTargetInstanceIps: catalogConfig?.nlbTargetInstanceIps || [],
            },
            internalNlbName: catalogConfig?.internalNlbName || null,
            albName: catalogConfig?.externalAlbName || null,
            nlbName: catalogConfig?.externalNlbName || null,
            albRuleName: catalogConfig?.externalAlbRuleName || null,
            instanceId: catalogConfig?.externalAlbExists === true && catalogConfig?.externalAlbTargetInstanceIds?.length ? 'yes' : 'no',
            targets: catalogConfig?.externalAlbTargetInstanceIds || [],
            targetNlbIpAddress: catalogConfig?.targetInstanceIps || [],
            nlbTargetInstanceIps: catalogConfig?.nlbTargetInstanceIps || [],
            isNlbRequired: catalogConfig?.externalNlbExists ? 'yes' : 'no',
            listenerPort: catalogConfig?.listeners?.port,
            listenerProtocol: catalogConfig?.listeners?.protocol,
            targetGrpName: catalogConfig?.externalAlbTargetGroup?.name,
            targetGrpNameNlb: catalogConfig?.externalNlbTargetGroupName || null,
            targetType: catalogConfig?.externalAlbTargetGroup?.targetType || 'IP',
            targetsDetail: { data: { value: catalogConfig?.externalAlbTargetGroup?.instanceId } },
            targetProtocol: catalogConfig?.externalAlbTargetGroup?.protocol,
            targetPort: catalogConfig?.externalAlbTargetGroup?.port,
            hcProtocol: catalogConfig?.healthCheck?.protocol,
            hcPath: catalogConfig?.healthCheck?.path,
            hcPort: catalogConfig?.healthCheck?.port,
        }),

        // EKS-specific fields
        ...(catalogConfig?.trafficType === TRAFFIC_TYPE.EKS && {
            eksClusterName: catalogConfig?.eksClusterName || null,
            eksClusterNameDetails: catalogConfig?.eksClusterName
                ? {
                      accountName: catalogConfig?.sharedNetworkAccount || null,
                      accountId: catalogConfig?.sharedNetworkAccountId || null,
                      name: catalogConfig?.externalNlbName || null,
                      arn: catalogConfig?.externalNlbArn || null,
                  }
                : null,
        }),
    };
};
export const resetOrder = {
    // Application Section
    entityDetails: null,
    appProfile: null,
    applicationName: null,
    sector: null,
    sectorDetails: null,
    department: null,
    appRegion: null,
    environment: null,
    hCode: null,
    hCodeDetails: null,
    appUrl: null,
    isAppUrlValid: false,
    appOwner: null,
    appOwnerDetails: null,
    dataClassification: null,
    adCertGroup: null,
    appSupportMailId: null,
    landingZoneDetails: null,

    // Resource Section
    availabilityZone: [],
    loadBalancerType: 'external',
    trafficType: TRAFFIC_TYPE.ALB,
    supportBackendCertificate: null,
    isAlbRequired: null,
    // Yes Scenario
    loadBalancerDetails: {
        albNameInternal: null,
        albArn: null,
        sharedNetworkAccount: null,
        nlbNameInternal: null,
        nlbArn: null,
        dnsName: null,
        accountId: null,
        nlbTargetInstanceIps: [],
        awsVpcId: null,
        subnets: null,
    },
    instanceId: 'no',
    targets: [],
    targetsDetail: [],
    // No Scenario
    appShortName: null,
    albName: null,
    targetGrpName: null,
    targetGrpNameNlb: null,
    listenerPort: 443,
    listenerProtocol: 'HTTPS',
    targetType: 'IP',
    targetPort: '80',
    targetProtocol: 'HTTP',
    hcProtocol: null,
    hcProtocolDetail: null,
    hcPath: null,
    hcPort: null,
    isNlbRequired: null,
    // Yes Scenario
    // nlbNameInternal and nlbArn are now in loadBalancerDetails
    // No Scenario
    nlbName: null,
    eksClusterName: null,
    eksClusterNameDetails: null,
    // appShortName: null,

    // Track which load balancer was set to "no" first for AppShortName cross-dependency
    albNoFirst: false,
    nlbNoFirst: false,

    tags: [],
    estimatedCost: {
        details: [],
        qty: null,
        totalOneTimeCost: {
            frequency: 'one time',
            estCost: null,
            currency: 'USD',
        },
        totalRecurringCost: {
            frequency: 'monthly',
            estCost: null,
            currency: 'USD',
        },
        notes: 'Total Est. Cost does not include the DR/backup services cost & any Pepsico internal chargebacks',
    },
    isaValidation: null,
    isaValidationMessage: null,
    isaValidationDetails: null,
    placeNewOrder: new Date(),
    validationStatus: 'clearValidation',
    isTouched: false,
};

export const resetToggleSspModal = {
    isCost: { costType: '', isCostOpen: false },
    isTagOpen: false,
    isApplicationOpen: false,
    isSubmitOrderSuccess: false,
    isUpdatedToCart: false,
    isCostSplitOpen: false,
};

export const resetCostEstimateDetails = {
    details: [],
    qty: null,
    totalOneTimeCost: {
        frequency: 'one time',
        estCost: null,
        currency: 'USD',
    },
    totalRecurringCost: {
        frequency: 'monthly',
        estCost: null,
        currency: 'USD',
    },
    notes: 'Total Est. Cost does not include the DR/backup services cost & any Pepsico internal chargebacks',
};

export const environmentConfigAppURL = {
    development: {
        regex: /^((?:(?!azure|aws|gcp)[a-z0-9-]){3,20})\.dev\.(mypepsico|pepsico)\.com$/,
        message: `Application URL is Invalid. Must be in the format: <appshortname>.dev.mypepsico.com or <appshortname>.dev.pepsico.com (where <appshortname> is 3–20 lowercase characters, must not contain '.', and may include hyphens). (e.g., devx-infra.dev.mypepsico.com). URL must not contain intra.pepsico.`,
    },
    qa: {
        regex: /^((?:(?!azure|aws|gcp)[a-z0-9-]){3,20})\.qa\.(mypepsico|pepsico)\.com$/,
        message: `Application URL is Invalid. Must be in the format: <appshortname>.qa.mypepsico.com or <appshortname>.qa.pepsico.com (where <appshortname> is 3–20 lowercase characters, must not contain '.', and may include hyphens). (e.g., devx-infra.qa.pepsico.com). URL must not contain intra.pepsico.`,
    },
    'pre-production': {
        regex: /^((?:(?!azure|aws|gcp)[a-z0-9-]){3,20})\.preprod\.(mypepsico|pepsico)\.com$/,
        message: `Application URL is Invalid. Must be in the format: <appshortname>.preprod.mypepsico.com or <appshortname>.preprod.pepsico.com (where <appshortname> is 3–20 lowercase characters, must not contain '.', and may include hyphens). (e.g., devx-infra.preprod.pepsico.com). URL must not contain intra.pepsico.`,
    },
    production: {
        regex: /^((?:(?!azure|aws|gcp)[a-z0-9-]){3,20})\.(mypepsico|pepsico)\.com$/,
        message: `Application URL is Invalid. Must be in the format: <appshortname>.mypepsico.com or <appshortname>.pepsico.com (where <appshortname> is 3–20 lowercase characters, must not contain '.', and may include hyphens). (e.g., devx-infra.pepsico.com). URL must not contain intra.pepsico.`,
    },
};

export const validateAppURL = (url, environment) => {
    const config = environmentConfigAppURL[environment?.toLowerCase()];

    if (!config) {
        return {
            isValid: false,
            message: 'Invalid environment specified',
        };
    }
    if (url && url.toLowerCase().includes('intra.pepsico')) {
        return {
            isValid: false,
            message: 'Application URL must not contain intra.pepsico',
        };
    }
    let isValid = {
        isValid: true,
        message: '',
    };
    if (url !== null && url !== '') {
        isValid = config.regex.test(url);
    }
    return {
        isValid,
        message: isValid ? 'Valid URL' : config.message,
    };
};

export const isAppShortNameDisabled = (order, baseDisabled = false, componentContext = null) => {
    if (baseDisabled) {
        return true;
    }

    // If both ALB and NLB are "no" and there's an appShortName
    const bothRequireNo = order?.isAlbRequired === 'no' && order?.isNlbRequired === 'no';
    const hasAppShortName = order?.appShortName && order?.appShortName.trim() !== '';

    if (bothRequireNo && hasAppShortName) {
        // Check which load balancer was set to "no" first using a timestamp or priority
        // For now, use a simple rule: if both are "no", the first one that was interacted with stays enabled
        // We can track this using order.albNoFirst or order.nlbNoFirst flags

        if (order?.albNoFirst && componentContext === 'nlb') {
            return true; // Disable NLB if ALB was set to "no" first
        }
        if (order?.nlbNoFirst && componentContext === TRAFFIC_TYPE.ALB) {
            return true; // Disable ALB if NLB was set to "no" first
        }
    }

    return false;
};

export const getDefaultCertificate = (order) => {
    const { isValid } = validateAppURL(order?.appUrl, order?.environment);
    if (isValid) {
        if (order?.appUrl) {
            if (/^([a-zA-Z0-9-]{3,20})\.(mypepsico|pepsico)\.com$|^([a-zA-Z0-9-]{3,20})\.(dev|qa|preprod|ite)\.(mypepsico|pepsico)\.com$/.test(order?.appUrl)) {
                return 'Entrust Certificate';
            }
            if (
                /^([a-zA-Z0-9-]{3,20})\.(aws\.intra\.pepsico)\.com$|^([a-zA-Z0-9-]{3,20})\.(dev|qa|preprod|ite)\.(aws\.intra\.pepsico)\.com$/.test(
                    order?.appUrl
                )
            ) {
                return 'Pepsico Enterprise CA Certificate';
            }
        }
    }
    return null;
};

export const costPayload = ({ order = [], catalogCode }) => {
    const payload = {
        catalogServiceCode: catalogCode,
        quantity: 1,
        catalogConfig: {
            environmentDetails: {
                region: order?.landingZoneDetails?.region,
                environment: order?.environment,
            },
            supportBackendCertificate: getDefaultCertificate(order),
        },
    };
    return payload;
};

export const isCrossDependencyActive = (order) => {
    return order?.isAlbRequired === 'no' && order?.isNlbRequired === 'no';
};

export const getAppShortNameHelperText = (order) => {
    if (isCrossDependencyActive(order) && order?.appShortName) {
        return 'Application Short Name is shared between ALB and NLB configurations.';
    }
    return null;
};

export const setLoadBalancerNoFirst = (order, setOrder, loadBalancerType) => {
    // Set the flag when a load balancer is set to "no" for the first time
    if (loadBalancerType === TRAFFIC_TYPE.ALB && !order?.albNoFirst && !order?.nlbNoFirst) {
        setOrder({
            ...order,
            albNoFirst: true,
        });
    } else if (loadBalancerType === 'nlb' && !order?.nlbNoFirst && !order?.albNoFirst) {
        setOrder({
            ...order,
            nlbNoFirst: true,
        });
    }
};

export const resetLoadBalancerFlags = (order, setOrder) => {
    // Reset flags when neither load balancer requires "no"
    if (order?.isAlbRequired !== 'no' && order?.isNlbRequired !== 'no') {
        setOrder({
            ...order,
            albNoFirst: false,
            nlbNoFirst: false,
            appShortName: null, // Clear appShortName when resetting
        });
    }
};

export const SECTION = {
    ISA_VALIDATION: 'isaValidation',
    SCAN_VALIDATION: 'scanValidation',
    CERTIFICATE_OWNER: 'certificateOwner',
    PROVISIONING: 'provisioning',
    SCAN_VALIDATION_MSG: 'Your ISA Validation has been completed, please enter the Scan Number For URL Validation',
};

export const getCurrentSection = (order) => {
    const { ISA_VALIDATION, SCAN_VALIDATION_MSG, PROVISIONING } = SECTION;
    if (order?.isaValidation === null || order?.isaValidation === undefined) return ISA_VALIDATION;
    if ((order?.isaValidation === true && order?.isaValidationMessage !== SCAN_VALIDATION_MSG) || order?.scanValidation === true) {
        return PROVISIONING;
    }
    if (order?.isaValidation === true && order?.isaValidationMessage === SCAN_VALIDATION_MSG) {
        // return SCAN_VALIDATION;
        return PROVISIONING;
    }
    if (order?.isaValidation === false) {
        // return SCAN_VALIDATION;
        return PROVISIONING;
    }
    return null;
};

export const isValidAppUrl = (appUrl) => {
    const isValid = /^((?:(?!azure|aws|gcp)[a-z0-9-]){3,20})\.(dev|qa|ite|preprod)?\.?(mypepsico|pepsico)\.com$/.test(appUrl);

    return { isValid };
};

/**
 * Extracts the environment value from a given App URL if it matches the pattern.
 * @param {string} url - The App URL to extract the environment from.
 * @returns {string|null} - The extracted environment value or null if not found.
 */
export const extractEnvironment = (url) => {
    const urlPattern = /^[a-z0-9-]{3,20}\.(dev|qa|ite|preprod)?\.?(mypepsico|pepsico)\.com$/;
    const match = url.match(urlPattern);
    return match ? match[1] : null;
};
/**
 * Returns the environment keys that match the given environment value.
 * @param {string} env - The environment value to check.
 * @returns {string[]} - The matching environment keys.
 */

export const getMatchingEnvironments = (env) => {
    const environmentOrder = {
        development: ['dev'],
        qa: ['qa'], // ite is not required here as per the requirement
        'pre-production': ['preprod', 'ite'],
        preprod: ['preprod', 'ite'],
        production: [],
    };

    return Object.keys(environmentOrder).filter((key) => environmentOrder[key].includes(env));
};
